import React from 'react';
import DOMPurify from 'dompurify';
import './ChatStreamResponseFormatting.scss';
import { markdownToHtml } from "../../../utils/commonUtils";

// Define the props type for the component
interface DynamicTextRendererProps {
    text: string;
  }
  
const DynamicTextRenderer: React.FC<DynamicTextRendererProps> = ({ text }) => { 
   
    return (
        <React.Fragment >
            <div className="custom-list" dangerouslySetInnerHTML={{ __html: markdownToHtml(DOMPurify.sanitize(text || '')) }} />
        </React.Fragment>
    );
  };


export default DynamicTextRenderer;